import { combineReducers, createStore } from 'redux';
import { reducer as formReducer } from 'redux-form';

import forms from './forms/forms';

const reducer = combineReducers({ forms, form: formReducer });

const store = createStore(
  reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;
export const { dispatch, getState } = store;



// WEBPACK FOOTER //
// ./src/store/store.js